import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FormControl } from '@angular/forms';
import { SubSink } from 'subsink';
import { IRadDropdown } from '@app/core/model/rad-components/rad-components';

export interface DropdownOption {
  value: any;
  text: string;
}

export interface RadDropdownSelectRendererParams extends ICellRendererParams {
  options: DropdownOption[];
  multiple?: boolean;
  label?: string;
  onSelectionChange?: (newValue: any, params: ICellRendererParams) => void;
  selectedOptionIdsPropertyName?: string;
}

@Component({
  selector: 'app-rad-dropdown-select-renderer',
  templateUrl: './rad-dropdown-select-renderer.component.html',
  styleUrls: ['./rad-dropdown-select-renderer.component.scss']
})
export class RadDropdownSelectRendererComponent implements OnInit, OnDestroy, ICellRendererAngularComp {
  public params: RadDropdownSelectRendererParams;
  public options: DropdownOption[] = [];
  public selectControl: FormControl = new FormControl();
  public isMultiple: boolean = false;
  public label: string;

  @ViewChild('dropdown', { static: false }) public dropdown: IRadDropdown;

  private subs = new SubSink();

  constructor() { }

  ngOnInit() {
    // Subscribe to value changes to notify the grid
    this.subs.sink = this.selectControl.valueChanges.subscribe(newValue => {
      if (this.params && this.params.onSelectionChange) {
        this.params.onSelectionChange(newValue, this.params);
      }
    });
  }

  public showDropdown() {
    this.dropdown.nativeElement.showDropdown();
  }

  hideDropdown() {
    this.dropdown.nativeElement.hideDropdown();
  }

  agInit(params: RadDropdownSelectRendererParams): void {
    this.params = params;
    
    // Set options from params or use rowData if available
    if (params.options) {
      this.options = params.options;
    } else if (params.data && params.data.options) {
      this.options = params.data.options;
    } else {
      this.options = [];
    }

    // Set multiple selection mode
    this.isMultiple = params.multiple || false;
    this.label = params.label;

    // Set initial value
    if (params.value !== null && params.value !== undefined) {
      this.selectControl.setValue(params.value, { emitEvent: false });
    }
  }

  refresh(params: RadDropdownSelectRendererParams): boolean {
    const selectedIds = params.data && params.data[this.params.selectedOptionIdsPropertyName] || [];
    
    // Update the form control value if it's changed externally
    const currentValue = this.selectControl.value || [];
    const hasChanged = JSON.stringify(currentValue) !== JSON.stringify(selectedIds);
    
    if (hasChanged) {
      this.selectControl.setValue(selectedIds, { emitEvent: false });
    }
    
    // Update options if they changed
    if (params.options && JSON.stringify(params.options) !== JSON.stringify(this.options)) {
      this.options = params.options;
    }
    
    return true;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
